<template lang="">
  <div class="login_wrap">
    <div class="login_area">
      <h2 class="h_login"><br><strong>ADMIN LOGIN</strong></h2>
      <div class="form_area">
        <p><input type="text" class="i_txt" placeholder="아이디를 입력하세요" v-model="username"></p>
        <p><input type="password" class="i_txt" placeholder="비밀번호를 입력하세요" v-model="pwd"></p>
        <p><span class="ui_chkbox primary small"><input type="checkbox" name=""><label for=""><span class="txt">아이디 저장</span></label></span></p>
        <button class="btn_login" @click="login">로그인</button>
        <!-- <button style="background-color: turquoise; width: 150px; height: 150px;" @click="checkSession"></button> -->
        
        <p class="vaild_area"><em>아이디 / 비밀번호</em>를 입력하세요</p>
      </div>
    </div>
    <p class="note">* 본 사이트는 관리자 전용 페이지입니다.<br><em>관리자만 접근</em> 가능합니다.</p>
  </div>
</template>
<script>

export default {
  data () {   
    return {
      username: '',
      pwd: '',
    }
  },

  methods: {
    async login() {
      const { username, pwd } = this
      this.$emit("login", { username, pwd })
    },

    checkSession() {
      this.$emit("checkSession")
    }
  }
}
</script>
<style lang="">
    
</style>